// client/src/components/Users/UserForm.jsx
import React, { useState, useEffect } from 'react';
import { Dialog, DialogTitle, DialogContent, DialogActions, TextField, Button, MenuItem, Grid, Alert } from '@mui/material';
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import axios from '../../api/axiosConfig';

const createUser = async (data) => axios.post('/users', data);
const updateUser = async ({ id, data }) => axios.put(`/users/${id}`, data);
const fetchRoles = async () => { const { data } = await axios.get('/roles'); return data; };
const fetchClients = async () => { const { data } = await axios.get('/clients'); return data; };

const UserForm = ({ open, onClose, user, onSuccess }) => {
  const [form, setForm] = useState({ username: '', email: '', password: '', fullName: '', phone: '', role: 'client', clientId: '' });
  const [error, setError] = useState('');
   // const { data: roles } = useQuery({ queryKey: ['roles'], queryFn: fetchRoles });
  const { data: roles, isLoading: rolesLoading, error: rolesError } = useQuery({
  queryKey: ['roles'],
  queryFn: fetchRoles,
});
  const { data: clients } = useQuery({ queryKey: ['clients'], queryFn: fetchClients, enabled: form.role === 'client' });

  useEffect(() => {
    if (user) {
      setForm({ ...user, password: '', clientId: user.clientId?._id || user.clientId || '' });
    } else {
      setForm({ username: '', email: '', password: '', fullName: '', phone: '', role: 'client', clientId: '' });
    }
  }, [user, open]);

  const mutation = useMutation({
    mutationFn: user ? updateUser : createUser,
    onSuccess: () => { onSuccess(); onClose(); },
    onError: (err) => setError(err.response?.data?.message || 'Error')
  });

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!user && !form.password) return setError('Password required');
    // Если роль не client, удаляем clientId
    const dataToSend = { ...form };
    if (dataToSend.role !== 'client') {
      delete dataToSend.clientId;
    }
    mutation.mutate(user ? { id: user._id, data: dataToSend } : dataToSend);
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>{user ? 'Edit User' : 'Add User'}</DialogTitle>
      <form onSubmit={handleSubmit}>
        <DialogContent>
          {error && <Alert severity="error" sx={{ mb: 2 }}>{error}</Alert>}
          <Grid container spacing={2}>
            <Grid item xs={12}><TextField fullWidth label="Username" required value={form.username} onChange={e => setForm({...form, username: e.target.value})} /></Grid>
            <Grid item xs={12}><TextField fullWidth label="Email" type="email" required value={form.email} onChange={e => setForm({...form, email: e.target.value})} /></Grid>
            {!user && <Grid item xs={12}><TextField fullWidth label="Password" type="password" required value={form.password} onChange={e => setForm({...form, password: e.target.value})} /></Grid>}
            <Grid item xs={12}><TextField fullWidth label="Full Name" required value={form.fullName} onChange={e => setForm({...form, fullName: e.target.value})} /></Grid>
            <Grid item xs={12}><TextField fullWidth label="Phone" value={form.phone} onChange={e => setForm({...form, phone: e.target.value})} /></Grid>
            <Grid item xs={12}>
              <TextField select fullWidth label="Role" value={form.role} onChange={e => setForm({...form, role: e.target.value, clientId: ''})}>
                {roles?.map(role => <MenuItem key={role.name} value={role.name}>{role.name}</MenuItem>)}
              </TextField>
            </Grid>
            {form.role === 'client' && (
              <Grid item xs={12}>
                <TextField select fullWidth label="Client" required value={form.clientId} onChange={e => setForm({...form, clientId: e.target.value})}>
                  {clients?.map(client => <MenuItem key={client._id} value={client._id}>{client.name}</MenuItem>)}
                </TextField>
              </Grid>
            )}
          </Grid>
        </DialogContent>
        <DialogActions>
          <Button onClick={onClose}>Cancel</Button>
          <Button type="submit" variant="contained">Save</Button>
        </DialogActions>
      </form>
    </Dialog>
  );
};

export default UserForm;